<template>
  <div class="business-introduction">
    <!-- 标题区域 -->
    <div class="section-header">
      <h2 class="section-title">{{ $t('home.business.title') }}</h2>
      <p class="section-subtitle">{{ $t('home.business.subtitle') }}</p>
      <div class="title-decoration"></div>
    </div>

    <!-- 业务卡片区域 -->
    <div class="business-cards">
      <div 
        v-for="(business, index) in businessList" 
        :key="index"
        class="business-card"
        :class="{ 
          'featured': index === 0,
          'hovered': hoverIndex === index
        }"
        :style="{ backgroundImage: `url(${business.backgroundImage})` }"
        @mouseenter="hoverIndex = index"
        @mouseleave="hoverIndex = -1"
      >
        <!-- 装饰背景 -->
        <div class="card-decoration"></div>
        
        <!-- 图标区域 -->
        <div class="card-icon" :style="{ backgroundColor: business.color }">
          <i :class="business.icon"></i>
        </div>
        
        <!-- 内容区域 -->
        <div class="card-content">
          <!-- 默认显示的底部内容 -->
          <div class="card-bottom">
            <div class="card-header">
              <h3 class="card-title">{{ business.title }}</h3>
              <div class="card-badge" v-if="index === 0">{{ $t('home.business.coreTag') }}</div>
            </div>
          </div>
          
          <!-- 悬停时显示的完整内容 -->
          <div class="card-full">
            <div class="card-header">
              <h3 class="card-title">{{ business.title }}</h3>
              <div class="card-badge" v-if="index === 0">{{ $t('home.business.coreTag') }}</div>
            </div>
            <p class="card-description">{{ business.description }}</p>
            
            <!-- 特性列表 -->
            <ul class="feature-list">
              <li v-for="(feature, featureIndex) in business.features" :key="featureIndex">
                <span class="feature-icon">
                  <i class="el-icon-check"></i>
                </span>
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
        
        <!-- 背景覆盖层，确保文字可读性 -->
        <div class="background-overlay"></div>
        
        <!-- 悬停效果背景 -->
        <div class="hover-bg" :style="{ background: business.gradient }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSectionTypeContent } from '../../api/system'

export default {
  name: 'BusinessIntroduction',

  data() {
    return {
      hoverIndex: -1,
      businessList: []
    }
  },
  
  methods: {
    // 从后端获取业务数据的方法
    async fetchBusinessData() {
      try {
        // 调用后端API获取业务介绍数据
        const language = this.$i18n.locale || 'zh-CN';
        const response = await getSectionTypeContent('business_intro', language);
        console.log('业务介绍API响应:', response);
        
        if (response.data && response.data.success && response.data.data) {
          this.processBusinessData(response.data.data);
        } else {
          console.warn('API did not return business intro data, using fallback data.');
          this.useFallbackData();
        }
        
      } catch (error) {
        console.error('获取业务数据失败:', error);
        // 使用降级数据
        this.useFallbackData();
      }
    },
    
    // 处理从API获取的业务数据
    processBusinessData(apiData) {
      // 将API返回的数据映射到组件数据结构
      const processedData = [];
      
      // 根据section_key映射数据
      apiData.forEach(item => {
        switch(item.sectionKey) {
          case 'core_business':
            processedData.push({
              title: item.title,
              description: item.subtitle,
              icon: item.icon,
              color: item.color,
              gradient: 'linear-gradient(135deg, ' + item.color + ' 0%, #8BC34A 100%)',
              backgroundImage: item.imageUrl || require('@/assets/img/home/qiche.png'),
              features: this.parseFeatures(item.content) || [
                this.$t('home.business.carLogistics.features.0'),
                this.$t('home.business.carLogistics.features.1'),
                this.$t('home.business.carLogistics.features.2'),
                this.$t('home.business.carLogistics.features.3')
              ]
            });
            break;
          // case 'energy_logistics':
          //   processedData.push({
          //     title: item.title || this.$t('home.business.energyLogistics.title'),
          //     description: item.content || this.$t('home.business.energyLogistics.description'),
          //     icon: 'el-icon-lightning',
          //     color: '#2196F3',
          //     gradient: 'linear-gradient(135deg, #2196F3 0%, #03A9F4 100%)',
          //     backgroundImage: require('@/assets/img/home/xinnengyuan.png'),
          //     features: this.parseFeatures(item.subtitle) || [
          //       this.$t('home.business.energyLogistics.features.0'),
          //       this.$t('home.business.energyLogistics.features.1'),
          //       this.$t('home.business.energyLogistics.features.2'),
          //       this.$t('home.business.energyLogistics.features.3')
          //     ]
          //   });
          //   break;
          // case 'solar_logistics':
          //   processedData.push({
          //     title: item.title || this.$t('home.business.solarLogistics.title'),
          //     description: item.content || this.$t('home.business.solarLogistics.description'),
          //     icon: 'el-icon-sunny',
          //     color: '#FF9800',
          //     gradient: 'linear-gradient(135deg, #FF9800 0%, #FFC107 100%)',
          //     backgroundImage: require('@/assets/img/home/guangfu.png'),
          //     features: this.parseFeatures(item.subtitle) || [
          //       this.$t('home.business.solarLogistics.features.0'),
          //       this.$t('home.business.solarLogistics.features.1'),
          //       this.$t('home.business.solarLogistics.features.2'),
          //       this.$t('home.business.solarLogistics.features.3')
          //     ]
          //   });
          //   break;
          // case 'container_logistics':
          //   processedData.push({
          //     title: item.title || this.$t('home.business.containerLogistics.title'),
          //     description: item.content || this.$t('home.business.containerLogistics.description'),
          //     icon: 'el-icon-refrigerator',
          //     color: '#9C27B0',
          //     gradient: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 100%)',
          //     backgroundImage: require('@/assets/img/home/lenggan.jpg'),
          //     features: this.parseFeatures(item.subtitle) || [
          //       this.$t('home.business.containerLogistics.features.0'),
          //       this.$t('home.business.containerLogistics.features.1'),
          //       this.$t('home.business.containerLogistics.features.2'),
          //       this.$t('home.business.containerLogistics.features.3')
          //     ]
          //   });
          //   break;
          // case 'steel_logistics':
          //   processedData.push({
          //     title: item.title || this.$t('home.business.steelLogistics.title'),
          //     description: item.content || this.$t('home.business.steelLogistics.description'),
          //     icon: 'el-icon-s-data',
          //     color: '#607D8B',
          //     gradient: 'linear-gradient(135deg, #607D8B 0%, #78909C 100%)',
          //     backgroundImage: require('@/assets/img/home/juangang.png'),
          //     features: this.parseFeatures(item.subtitle) || [
          //       this.$t('home.business.steelLogistics.features.0'),
          //       this.$t('home.business.steelLogistics.features.1'),
          //       this.$t('home.business.steelLogistics.features.2'),
          //       this.$t('home.business.steelLogistics.features.3')
          //     ]
          //   });
          //   break;
        }
      });
      
      // 如果没有从API获取到数据，使用默认值
      if (processedData.length === 0) {
        this.useFallbackData();
      } else {
        this.businessList = processedData;
      }
    },
    
    // 解析特性列表
    parseFeatures(featuresText) {
      if (!featuresText) return null;
      // 支持分号分隔或数组格式
      if (Array.isArray(featuresText)) {
        return featuresText;
      }
      return featuresText.split(',').map(feature => feature.trim()).filter(feature => feature);
    },
    
    // 使用降级数据
    useFallbackData() {
      this.businessList = [
        {
          title: this.$t('home.business.carLogistics.title'),
          description: this.$t('home.business.carLogistics.description'),
          icon: 'el-icon-truck',
          color: '#4CAF50',
          gradient: 'linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)',
          backgroundImage: require('@/assets/img/home/qiche.png'),
          features: [
            this.$t('home.business.carLogistics.features.0'),
            this.$t('home.business.carLogistics.features.1'),
            this.$t('home.business.carLogistics.features.2'),
            this.$t('home.business.carLogistics.features.3')
          ]
        },
        {
          title: this.$t('home.business.energyLogistics.title'),
          description: this.$t('home.business.energyLogistics.description'),
          icon: 'el-icon-lightning',
          color: '#2196F3',
          gradient: 'linear-gradient(135deg, #2196F3 0%, #03A9F4 100%)',
          backgroundImage: require('@/assets/img/home/xinnengyuan.png'),
          features: [
            this.$t('home.business.energyLogistics.features.0'),
            this.$t('home.business.energyLogistics.features.1'),
            this.$t('home.business.energyLogistics.features.2'),
            this.$t('home.business.energyLogistics.features.3')
          ]
        },
        {
          title: this.$t('home.business.solarLogistics.title'),
          description: this.$t('home.business.solarLogistics.description'),
          icon: 'el-icon-sunny',
          color: '#FF9800',
          gradient: 'linear-gradient(135deg, #FF9800 0%, #FFC107 100%)',
          backgroundImage: require('@/assets/img/home/guangfu.png'),
          features: [
            this.$t('home.business.solarLogistics.features.0'),
            this.$t('home.business.solarLogistics.features.1'),
            this.$t('home.business.solarLogistics.features.2'),
            this.$t('home.business.solarLogistics.features.3')
          ]
        },
        {
          title: this.$t('home.business.containerLogistics.title'),
          description: this.$t('home.business.containerLogistics.description'),
          icon: 'el-icon-refrigerator',
          color: '#9C27B0',
          gradient: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 100%)',
          backgroundImage: require('@/assets/img/home/lenggan.jpg'),
          features: [
            this.$t('home.business.containerLogistics.features.0'),
            this.$t('home.business.containerLogistics.features.1'),
            this.$t('home.business.containerLogistics.features.2'),
            this.$t('home.business.containerLogistics.features.3')
          ]
        },
        {
          title: this.$t('home.business.steelLogistics.title'),
          description: this.$t('home.business.steelLogistics.description'),
          icon: 'el-icon-s-data',
          color: '#607D8B',
          gradient: 'linear-gradient(135deg, #607D8B 0%, #78909C 100%)',
          backgroundImage: require('@/assets/img/home/juangang.png'),
          features: [
            this.$t('home.business.steelLogistics.features.0'),
            this.$t('home.business.steelLogistics.features.1'),
            this.$t('home.business.steelLogistics.features.2'),
            this.$t('home.business.steelLogistics.features.3')
          ]
        }
      ];
    }
  },
  
  mounted() {
    // 组件挂载时获取数据
    this.fetchBusinessData();
    
    // 监听语言变化
    this.$watch('$i18n.locale', () => {
      this.fetchBusinessData();
    });
  }
}
</script>

<style lang="scss" scoped>
.business-introduction {
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../../assets/img/home/bg_02.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.5;
    z-index: 0;
    filter: brightness(1.1) contrast(1.1);
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
    z-index: 1;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
  
  .section-title {
    font-size: 3rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 16px;
    position: relative;
    letter-spacing: -0.8px;
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    
    @media (max-width: 768px) {
      font-size: 2.2rem;
    }
  }
  
  .section-subtitle {
    font-size: 1.2rem;
    color: #64748b;
    margin-bottom: 30px;
    font-weight: 400;
    line-height: 1.6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    letter-spacing: -0.2px;
  }
  
  .title-decoration {
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);
    margin: 0 auto;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
}

.business-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 32px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 0 15px;
  }
}

.business-card {
  position: relative;
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  border: 1px solid #f1f5f9;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 420px;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
    border-color: #e2e8f0;
    
    .hover-bg {
      opacity: 0.05;
    }
    
    .card-icon {
      transform: scale(1.1) rotate(5deg);
    }
    
    .card-decoration {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }
  
  &.featured {
    border: 1px solid #3b82f6;
    background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 100px;
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
      border-radius: 0 20px 0 100px;
      opacity: 0.1;
    }
  }
}

.card-decoration {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 50%;
  opacity: 0.05;
  transition: all 0.4s ease;
  z-index: 1;
}

.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 15px;
  
  .card-badge {
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    color: white;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
}

.card-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  color: white;
  font-size: 1.8rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  z-index: 2;
  align-self: flex-start;
}

.card-content {
  position: relative;
  z-index: 3;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.card-bottom {
  background: linear-gradient(to top, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.6) 100%);
  padding: 25px;
  padding-top: 0;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 -10px;
  width: calc(100% + 20px);
}

.card-full {
  position: absolute;
  top: 100%;
  left: -15px;
  right: -15px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%);
  padding: 35px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateY(20px);
  min-height: 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: calc(100% + 30px);
}

.business-card.hovered {
  .card-bottom {
    opacity: 0;
    transform: translateY(20px);
  }
  
  .card-full {
    opacity: 1;
    transform: translateY(-100%);
  }
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
  line-height: 1.3;
  letter-spacing: -0.3px;
  flex: 1;
}

.card-description {
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 24px;
  font-size: 1rem;
  letter-spacing: -0.1px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0px;
    color: #475569;
    font-size: 0.95rem;
    line-height: 1.5;
    
    .feature-icon {
      color: #3b82f6;
      margin-right: 12px;
      font-size: 1rem;
      margin-top: 2px;
      flex-shrink: 0;
      background: #eff6ff;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  z-index: 1;
  pointer-events: none;
  transition: all 0.4s ease;
}

.business-card.hovered .background-overlay {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.4) 100%);
}

.hover-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
}

// 响应式设计
@media (max-width: 768px) {
  .business-introduction {
    padding: 60px 0;
  }
  
  .business-card {
    padding: 25px;
    
    &.featured::before {
      top: 15px;
      right: 15px;
      font-size: 0.7rem;
      padding: 3px 10px;
    }
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
    font-size: 1.3rem;
  }
  
  .cta-section {
    margin-top: 60px;
    padding: 30px 20px;
  }
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.business-card {
  animation: fadeInUp 0.5s ease forwards;
  
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      animation-delay: #{$i * 0.1}s;
    }
  }
}
</style>
